import { render, staticRenderFns } from "./ApplicationFeedbackSingle.vue?vue&type=template&id=53b73ea2&"
import script from "./ApplicationFeedbackSingle.vue?vue&type=script&lang=js&"
export * from "./ApplicationFeedbackSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports